module.exports = __webpack_public_path__ + "static/media/hiking.ed69bc03.jpeg";


//////////////////
// WEBPACK FOOTER
// ./images/other/hiking.jpeg
// module id = 448
// module chunks = 0